import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { Title } from '@angular/platform-browser';
import { UntilDestroy } from '@ngneat/until-destroy';
import { constants } from 'src/app/core/constants/constants';

@UntilDestroy()
@Component({
  selector: 'app-access-restricted',
  templateUrl: './access-restricted.component.html',
  styleUrl: './access-restricted.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccessRestrictedComponent implements OnInit {
  constructor(
    private titleService: Title,
    private readonly cdr: ChangeDetectorRef,
  ) {}

  public constants = constants;

  ngOnInit() {
    this.titleService.setTitle('AutoLex | Access restricted');
    this.cdr.markForCheck();
  }
}
